import { render, staticRenderFns } from "./ReviewsDetails.vue?vue&type=template&id=7d1fdbca&scoped=true&"
import script from "./ReviewsDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsDetails.vue?vue&type=style&index=0&id=7d1fdbca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fdbca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1fdbca')) {
      api.createRecord('7d1fdbca', component.options)
    } else {
      api.reload('7d1fdbca', component.options)
    }
    module.hot.accept("./ReviewsDetails.vue?vue&type=template&id=7d1fdbca&scoped=true&", function () {
      api.rerender('7d1fdbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/ReviewsDetails.vue"
export default component.exports